// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "monthsWrapperStyles_wrapper-1FVUG";
var _4 = "monthWrapper-J3YQ6";
var _5 = "week-1ZJnx";
var _6 = "day-3O05O";
var _7 = "day_notAvailable-33kDA";
var _8 = "day_selected-28bOk";
var _9 = "day_today-1McDG";
var _a = "day_highlight-3QrhA";
export { _1 as "__esModule", _2 as "mobile", _3 as "monthsWrapperStyles_wrapper", _4 as "monthWrapper", _5 as "week", _6 as "day", _7 as "day_notAvailable", _8 as "day_selected", _9 as "day_today", _a as "day_highlight" }
export default { "__esModule": _1, "mobile": _2, "monthsWrapperStyles_wrapper": _3, "monthWrapper": _4, "week": _5, "day": _6, "day_notAvailable": _7, "day_selected": _8, "day_today": _9, "day_highlight": _a }
